import React from 'react';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';
import { Tooltip } from 'reactstrap';
import { FaFileExport } from "react-icons/fa";
import { PiNumpadBold } from "react-icons/pi";
import { IoIosRefreshCircle } from "react-icons/io";
import { FaTrash } from "react-icons/fa";
import { MdCheckBoxOutlineBlank } from "react-icons/md";
import { MdCheckBox } from "react-icons/md";
import 'Css/report.css';

class Report extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      toolTipShow: false,
      pageNumber: 0
    };

    this.props.fetchLog(0);
    this.targetRef = React.createRef();
  }

  componentDidMount() {
    this.props.setSidebarVoice("report");
    $(() => {
      document.querySelector("body").addEventListener("scroll", () => this.onScroll());
    });
  }

  onChangePage(event, newPage) {
    if (!newPage) { return; }
    this.props.fetchLog(newPage - 1);
    this.setState({ pageNumber: parseInt(newPage - 1) });
  }

  onScroll() {
    this.setState({ toolTipShow: false });
  }

  onManageToolTip(toolTipId) {
    let toolTipShow = this.state.toolTipShow || {};
    toolTipShow[toolTipId] = toolTipShow[toolTipId] != null ? null : true;
    this.setState({ toolTipShow });
  }

  downloadPDF = () => {
    let rowsToGenerator = [];
    for (let k in this.state.checkReportRows) {
      if (this.state.checkReportRows[k]) rowsToGenerator.push(k);
    }
    if (rowsToGenerator.length === 0) {
      alert("Selezionare le righe da esportare");
      return;
    }
    this.props.generateReportPdf(rowsToGenerator);
  }

  deleteReport = () => {
    let rowsToDelete = [];
    for (let k in this.state.checkReportRows) {
      if (this.state.checkReportRows[k]) rowsToDelete.push(k);
    }
    if (rowsToDelete.length === 0) {
      alert("Selezionare le righe da eliminare");
      return;
    }
    this.props.setShowModaleConferma({
      header: "Elimina record",
      body: "Procedere con l'eliminazione dei record selezionati?",
      esegui: () => {
        this.props.deleteRecordRows(rowsToDelete);
        this.props.setShowModaleConferma(null)
      }
    });
  }

  initReportCheckbox(index, value) {
    let checkReportRows = this.state.checkReportRows ? this.state.checkReportRows : {};
    if (!(index in checkReportRows)) {
      checkReportRows[index] = value;
      this.setState({ checkReportRows });
    }
  }

  toggleReportCheckbox(index) {
    let checkReportRows = this.state.checkReportRows || {};
    if (index === "all") {
      const checkReportRowsAll = this.state.checkReportRowsAll ? false : true;
      this.setState({ checkReportRowsAll });
      Object.keys(checkReportRows).forEach(k => (checkReportRows[k] = checkReportRowsAll));
    } else {
      checkReportRows[index] = checkReportRows[index] ? false : true;
    }
    this.setState({ checkReportRows });
  }

  // ------- helpers data/ora --------

  // I log “nuovi” (this.props.logs.logs) hanno ts = epoch locale del device.
  // Per visualizzare correttamente nel browser, togliamo l’offset locale del browser.
  dateFromLocalEpoch(tsSec) {
    if (!tsSec) return null;
    const offsetSec = -new Date().getTimezoneOffset() * 60; // es. +7200 per UTC+2
    const ms = (tsSec - offsetSec) * 1000;
    return new Date(ms);
  }

  // Legacy: i vecchi log (this.props.logs.pins) arrivano con log.date già usato in app.
  // Manteniamo il comportamento precedente (sottraeva 2 ore).
  dateFromLegacy(dateVal) {
    const d = new Date(dateVal);
    // manteniamo l’hack storico:
    d.setHours(d.getHours() - 2);
    return d;
  }

  // Normalizza e unisce: prima i log “nuovi”, poi i legacy.
  getMergedLogs() {
    const pins = (this.props.logs && Array.isArray(this.props.logs.pins)) ? this.props.logs.pins : [];
    const dbLogs = (this.props.logs && Array.isArray(this.props.logs.logs)) ? this.props.logs.logs : [];

    const mappedDb = dbLogs.map(l => {
      const d = this.dateFromLocalEpoch(l.ts) || (l.receivedAt ? new Date(l.receivedAt) : null);
      return {
        // campi usati dal render:
        id: l.id,
        name: l.name || '',
        lastName: '',                 // nei nuovi non c'è cognome separato
        pin: l.pin ? (l.pin +(!l.ok? " (Errato)" : "")) : '',
        deviceName: l.deviceName || l.serialNumber || '-',
        _date: d,
        _source: 'db',
      };
    });

    const mappedLegacy = pins.map(l => {
      const d = this.dateFromLegacy(l.date);
      return {
        id: l.id,
        name: l.name || '',
        lastName: l.lastName || '',
        pin: l.pin || '',
        deviceName: l.deviceName || '-',
        _date: d,
        _source: 'legacy',
      };
    });

    // Ordina tutti i log per data decrescente (i null vanno in fondo)
    const all = [...mappedDb, ...mappedLegacy].sort((a, b) => {
      if (!a._date && !b._date) return 0;
      if (!a._date) return 1;
      if (!b._date) return -1;
      return b._date.getTime() - a._date.getTime();
    });

    return all;
  }

  render() {
    const mobileVer = window.outerWidth < 455;
    const mergedLogs = this.getMergedLogs();
    console.log("mergedLogs", mergedLogs);

    const logsHtml = mergedLogs && mergedLogs.length > 0 ? mergedLogs.map((log, index) => {
      const date = log._date ? new Date(log._date) : null;

      // format date/time
      const day = date ? String(date.getDate()).padStart(2, '0') : '--';
      const month = date ? String(date.getMonth() + 1).padStart(2, '0') : '--';
      const year = date ? date.getFullYear() : '----';
      const hours = date ? String(date.getHours()).padStart(2, '0') : '--';
      const minutes = date ? String(date.getMinutes()).padStart(2, '0') : '--';
      const seconds = date ? String(date.getSeconds()).padStart(2, '0') : '--';

      const toolTipId = date
        ? ([day, month, year].join("/") + [hours, minutes, seconds].join(":"))
            .replaceAll("/", "")
            .replaceAll(":", "")
        : `row_${log.id}`;

      const logFromApp = log.pin && log.pin.indexOf("@") !== -1;

      // init checkbox state (una sola volta)
      (!this.state.checkReportRows || !(log.id in (this.state.checkReportRows || {})))
        ? this.initReportCheckbox(log.id, false)
        : "";

      return (
        <TableRow key={`${log._source}_${log.id}`} style={index % 2 ? { background: "rgba(0,0,35,0.1)" } : { background: "white" }}>
          <TableCell align="center">
            <button className="checkReportRow" onClick={() => this.toggleReportCheckbox(log.id)}>
              {this.state.checkReportRows && this.state.checkReportRows[log.id] ? <MdCheckBox /> : <MdCheckBoxOutlineBlank />}
            </button>
          </TableCell>

          {mobileVer && logFromApp ? (
            <TableCell align="center">
              <button className="btn btn-sm btn-secondary" href="#" id={"tt_" + toolTipId}>
                <i className="fas fa-user-shield"></i>
              </button>
              <Tooltip
                placement="right"
                isOpen={this.state.toolTipShow && this.state.toolTipShow[toolTipId]}
                target={"tt_" + toolTipId}
                toggle={() => this.onManageToolTip(toolTipId)}
              >
                {log.pin}
              </Tooltip>
            </TableCell>
          ) : (
            <TableCell style={{ maxWidth: "10em", wordWrap: "break-word" }} align="center">
              <div>{log.name} {log.lastName}</div>
              <div style={{ fontWeight: logFromApp ? '' : 'bold', color: 'rgba(0,0,0,.75)' }}>
                {log.name ? <PiNumpadBold /> : ""} {log.pin ? log.pin : ""}
              </div>
            </TableCell>
          )}

          <TableCell align="center">{log.deviceName || '-'}</TableCell>
          <TableCell align="center">{date ? [day, month, year].join("/") : '--/--/----'}</TableCell>
          <TableCell align="center">{date ? [hours, minutes, seconds].join(":") : '--:--:--'}</TableCell>
        </TableRow>
      );
    }) : null;

    return (
      <div id="report" ref={this.targetRef}>
        <div id="reportHeadTools">
          <button id="exportBtn" onClick={() => this.downloadPDF()}>
            <FaFileExport />
            <label>{this.props.getLocale().REPORT_TABLE_EXPORT}</label>
          </button>
          <button id="refreshBtn" onClick={() => { this.setState({ pageNumber: 0 }); this.props.fetchLog(0); }}>
            <IoIosRefreshCircle />
            <label>{this.props.getLocale().REPORT_TABLE_UPDATE}</label>
          </button>
          <button id="deleteBtn" onClick={() => this.deleteReport()}>
            <FaTrash />
            <label>{this.props.getLocale().REPORT_TABLE_DELETE}</label>
          </button>
        </div>

        <div id="line" />

        <div id="reportBody">
          <label id="reportInfoText">{this.props.getLocale().REPORT_INFO}</label>

          {this.props.fetchLogLoading ? (
            <CircularProgress />
          ) : (
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableCell align="center">
                    <button className="checkReportRow" onClick={() => this.toggleReportCheckbox("all")}>
                      {this.state.checkReportRowsAll ? <MdCheckBox /> : <MdCheckBoxOutlineBlank />}
                    </button>
                  </TableCell>
                  <TableCell align="center">
                    <strong>{this.props.getLocale().REPORT_TABLE_USER}</strong>
                  </TableCell>
                  <TableCell align="center">
                    <strong>{this.props.getLocale().REPORT_TABLE_DEVICE}</strong>
                  </TableCell>
                  <TableCell align="center">
                    <strong>{this.props.getLocale().REPORT_TABLE_DATE}</strong>
                  </TableCell>
                  <TableCell align="center">
                    <strong>{this.props.getLocale().REPORT_TABLE_HOUR}</strong>
                  </TableCell>
                </TableHead>
                <TableBody>
                  {logsHtml}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </div>
      </div>
    );
  }
}

export default Report;
export { Report };
